import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../shared/hooks';
import { ROUTES } from '../../types/routes';
import { Onboarding } from '../../types/userTypes';

type Props = {};

const CommunityTagmangoTeam: React.FC<Props> = () => {
  const navigate = useNavigate();
  const userDetails = useAppSelector((state) => state?.user);

  useEffect(() => {
    if (userDetails?.type === Onboarding.FAN_COMPLETED) {
      navigate(ROUTES.COMMUNITY_FEED);
    }
  }, [navigate, userDetails?.type]);
  return <div>CommunityTagmangoTeam</div>;
};

export default CommunityTagmangoTeam;
